import axios from 'axios';
import { Cage } from 'types/shared/cage.type';
import { FieldCollection } from '../types/field-collection.type';
import { FieldCollectionListItem } from '../types/field-collection-list-item.type';
import { FieldCollectionType } from '../types/field-collection-type.enum';

// GET
// /ewosapi/v1/fieldregistration/fieldcollection/{fieldCollectionId}
export const getFieldCollection = async (fieldCollectionId: number): Promise<FieldCollection> => {
  const res = await axios.get<FieldCollection>(`/ewosapi/v1/fieldregistration/fieldcollection/${fieldCollectionId}`);
  return res.data;
};

// GET
// /ewosapi/v1/fieldregistration/company/{globalCompanyId}/fieldcollection
export const getFieldCollectionByCompany = async (
  globalCompanyId: string,
  type: FieldCollectionType,
  active?: boolean,
  fromDate?: string,
  toDate?: string
): Promise<FieldCollectionListItem[]> => {
  const res = await axios.get(`/ewosapi/v1/fieldregistration/company/${globalCompanyId}/fieldcollection`, {
    params: { fromDate, toDate, active, type },
  });
  return res.data;
};

// GET
// /ewosapi/v1/fieldregistration/site/{globalSiteId}/cage
export const getFieldCollectionCages = async (globalSiteId: string): Promise<Cage[]> => {
  const res = await axios.get<Cage[]>(`/ewosapi/v1/fieldregistration/site/${globalSiteId}/cage`);
  return res.data;
};
